import { FC } from 'react';

import { useIntersectionObserver } from 'shared/hooks/useIntersectionObserver';
import { useGetOffersQuery } from 'shared/store/serverSide/commercial-search-offers/desktop/v2/offers/get-offers/query';

import { SEOBottomLinksBlock } from '../SEOBottomLinksBlock';

import { trackCrosslinksClick, trackCrosslinksShown } from './internal/tracking';

export const CrosslinksContainer: FC = () => {
  const { data: crosslinks } = useGetOffersQuery({ select: data => data.seo.view.crosslinks });

  const { elementRef } = useIntersectionObserver<HTMLDivElement>({
    deps: [crosslinks],
    observerOptions: { threshold: 0.5 },
    onInViewport({ subscribeState, observer }) {
      trackCrosslinksShown();

      observer.disconnect();
      subscribeState.setSubscribeUnavailable();
    },
  });

  if (!crosslinks) {
    return null;
  }

  return (
    <SEOBottomLinksBlock
      links={crosslinks.items}
      ref={elementRef}
      title={crosslinks.title}
      trackLinkClick={trackCrosslinksClick}
    />
  );
};
